import { render, staticRenderFns } from "./pkqUserPointsRecord.vue?vue&type=template&id=01816e54&scoped=true"
import script from "./pkqUserPointsRecord.vue?vue&type=script&lang=js"
export * from "./pkqUserPointsRecord.vue?vue&type=script&lang=js"
import style0 from "./pkqUserPointsRecord.vue?vue&type=style&index=0&id=01816e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01816e54",
  null
  
)

export default component.exports